import { useState } from 'react';

export function useCustomerSearch(updateFilters) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    // Auto-update filter when 3 or more characters
    if (value.length >= 3) {
      updateFilters({ searchText: value });
    } else if (value.length === 0) {
      // Clear filter when search is empty
      updateFilters({ searchText: '' });
    }
  };

  return {
    searchTerm,
    handleSearchChange
  };
}
